import { upcomingActionsSlice } from './upcoming-actions.slice';
import * as actions from './actions';
import * as selectors from './selectors';

export const upcomingActionsMethods = {
  ...upcomingActionsSlice.actions,
  ...actions,
};

export const upcomingActionsSelectors = {
  ...selectors,
};
